import React from "react";
import { Spinner } from "components/Spinner";
import "./centeredLayout.scss";

const CenteredLayout = (props) => {
  const { className, children, isLoaded, loadingMsg } = props;
  return (
    <div className="centered-page-wrapper">
      <div className={`centered-page-content ${className}`}>
        {isLoaded === undefined || !!isLoaded ? (
          children
        ) : (
          <Spinner
            msg={loadingMsg ? loadingMsg : "Loading..."}
            style={{ width: "3rem", height: "3rem" }}
            color="primary"
          />
        )}
      </div>
    </div>
  );
};

export { CenteredLayout };
